// Imports
import * as Fianza from '@fianza/shared/constants';
import * as CarInsurance from '@car-insurance/shared/constants';
import * as Users from '@users/utils/constants/users';
import * as Accidents from '@accidents/shared/constants';
import * as CouponsCampaign from '@app/modules/coupons/utils/constants/coupons';
import * as Accounts from '@accounts/shared/constants';
import * as Cartera from '@modules/cartera/shared/constants';
import * as Renewals from '@renewals-module/utils/constants/renewals.constants';
import * as MultiProducts from '@multi-products/shared/constants';
import * as Transport from '@transport-module/shared/constants/routing';
import * as RentGuarantee from '@rent-guarantee/utils/constants/rent-guarantee';
import * as Settings from '@settings-module/utils/constants/settings';
import * as Travel from '@travel/utils/constants/index';
import * as AutomobilePricing from '@automobile-pricing/utils/constants/index';

export const APP_PATHS_CONSTANTS = {
  // Login
  ADMIN_LOGIN: 'login',
  ADMIN_PASSWORD_RECOVERY: 'password-recovery',
  ADMIN_USER_ACTIVATION: 'activation',
  // Private Wrapper
  ADMIN_PRIVATE_WRAPPER: 'private',
  // Dashboard
  DASHBOARD_AUTO: '',
  // Password Change
  PASSWORD_CHANGE: 'change-password',
  // View Profile
  VIEW_PROFILE: 'view-profile',
  // Car Insurance Module
  CAR_INSURANCE_MODULE: CarInsurance.MODULE_PATHS_CONSTANTS.BASE_ROUTE,
  //Gestión de tarifa automóviles
  AUTOMOBILE_PRICING: AutomobilePricing.MODULE_PATHS_CONSTANTS.BASE_ROUTE,
  // Cuentas Module
  ACCOUNTS: Accounts.MODULE_PATHS_CONSTANTS.BASE_ROUTE,
  // Fianza Module
  FIANZA_MODULE: Fianza.MODULE_PATHS_CONSTANTS.BASE_ROUTE,
  // Cartera Module
  CARTERA_MODULE: Cartera.MODULE_PATHS_CONSTANTS.BASE_ROUTE,
  // Users Module
  USERS_MODULE: Users.MODULE_PATHS_CONSTANTS.BASE_ROUTE,
  // Accidents Module
  ACCIDENTS_MODULE: Accidents.MODULE_PATHS_CONSTANTS.BASE_ROUTE,
  // Campañas Module
  COUPONS_CAMPAIGN: CouponsCampaign.MODULE_PATHS_CONSTANTS.BASE_ROUTE,
  // MultiProductos
  MULTI_PRODUCTS: MultiProducts.MODULE_PATHS_CONSTANTS.BASE_ROUTE,
  // Renewals
  RENEWALS: Renewals.MODULE_PATHS_CONSTANTS.BASE_ROUTE,
  //Transport
  TRANSPORT: Transport.MODULE_PATHS_CONSTANTS.BASE_ROUTE,
  //Rent Guarantee
  RENT_GUARANTEE: RentGuarantee.MODULE_PATHS_CONSTANTS.BASE_ROUTE,
  //Travel
  TRAVEL: Travel.MODULE_PATHS_CONSTANTS.BASE_ROUTE,
  //Settings
  SETTINGS: Settings.MODULE_PATHS_CONSTANTS.BASE_ROUTE,
};

export const APP_NAVIGATION_MENU = [
  ...CarInsurance.MODULE_NAVIGATION_MENU,
  ...AutomobilePricing.MODULE_NAVIGATION_MENU,
  ...MultiProducts.MODULE_NAVIGATION_MENU,
  ...Transport.MODULE_NAVIGATION_MENU,
  ...Fianza.MODULE_NAVIGATION_MENU,
  ...Accounts.MODULE_NAVIGATION_MENU,
  ...Cartera.MODULE_NAVIGATION_MENU,
  ...Renewals.MODULE_NAVIGATION_MENU,
  ...Accidents.MODULE_NAVIGATION_MENU,
  ...CouponsCampaign.MODULE_NAVIGATION_MENU,
  ...Users.MODULE_NAVIGATION_MENU,
  ...RentGuarantee.MODULE_NAVIGATION_MENU,
  ...Travel.MODULE_NAVIGATION_MENU,
  ...Settings.MODULE_NAVIGATION_MENU,
];

export const APP_ROUTES_NOT_MENU = [
  {
    icon: 'pi pi-key',
    route: APP_PATHS_CONSTANTS.PASSWORD_CHANGE,
    title: 'Cambiar contraseña',
  },
  {
    icon: 'pi pi-user',
    route: APP_PATHS_CONSTANTS.VIEW_PROFILE,
    title: 'Ver perfil',
  },
  {
    icon: 'pi pi-clipboard',
    route: APP_PATHS_CONSTANTS.DASHBOARD_AUTO,
    title: 'Dashboard',
  },
  // Modules
  ...CarInsurance.MODULE_ROUTES_NOT_MENU,
  ...AutomobilePricing.MODULE_ROUTES_NOT_MENU,
  ...Fianza.MODULE_ROUTES_NOT_MENU,
  ...Cartera.MODULE_ROUTES_NOT_MENU,
  ...Accounts.MODULE_ROUTES_NOT_MENU,
  ...Users.MODULE_ROUTES_NOT_MENU,
  ...Accidents.MODULE_ROUTES_NOT_MENU,
  ...CouponsCampaign.MODULE_ROUTES_NOT_MENU,
  ...MultiProducts.MODULE_ROUTES_NOT_MENU,
  ...Renewals.MODULE_ROUTES_NOT_MENU,
  ...Transport.MODULE_ROUTES_NOT_MENU,
  ...RentGuarantee.MODULE_ROUTES_NOT_MENU,
  ...Travel.MODULE_ROUTES_NOT_MENU,
];
